<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">{{
          $t('administration.rgpd.contacts.title')
        }}</v-list-item-title>
        <v-list-item-subtitle>{{
          $t('administration.rgpd.contacts.subtitle')
        }}</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action class="d-print-none">
        <export
          :typeObjet="this.typeObjet"
          typeRecherche="simple"
          :datasourceContactExpire="datasourceContactExpire"
        />
      </v-list-item-action>
    </v-list-item>
    <v-card-text class="pt-0">
      <datasource-table
        v-model="selectedContact"
        :datasource="datasourceContactExpire"
        :callRefresh="true"
        :tableProps="{ showSelect: true }"
        ref="datasourceRef"
        @change="refresh()"
      >
        <template #item.raisonSociale="{item}">
          <router-link :to="$liens().personneMorale(item.idPersonneMorale)"
            >{{ item.raisonSociale }}
          </router-link>
        </template>

        <template #item.cotiseA="{item}">
          <router-link :to="$liens().personneMorale(item.idCotisable)"
            >{{ item.cotiseA }}
          </router-link>
        </template>

        <template #item.nom="{item}">
          <router-link
            :to="$liens().personnePhysique(item.idPersonnePhysique, item.id)"
          >
            {{ item.nom }}
          </router-link>
        </template>
        <template #item.prenoms="{item}">
          <router-link
            :to="$liens().personnePhysique(item.idPersonnePhysique, item.id)"
          >
            {{ item.prenoms }}
          </router-link>
        </template>

        <template #item.telephone="{item}">
          {{ item.telephone }}
          <v-tooltip v-if="item.telephoneConfidentiel" bottom>
            <template #activator="{ on }">
              <v-icon v-on="on">mdi-eye-off</v-icon>
            </template>
            <span>Confidentiel</span>
          </v-tooltip>
        </template>
        <template #item.dateLimiteValidite="{item}">
          {{ formatDate(item.dateLimiteValidite) }}
        </template>
      </datasource-table>

      <div class="d-flex">
        <v-spacer />
        <v-btn
          small
          outlined
          color="secondary"
          :disabled="datasourceContactExpire.items.length < 2"
          @click="demarreModifMasse"
          >Modification de masse</v-btn
        >
      </div>
    </v-card-text>

    <dialogModifMasse
      ref="dialogModifMasse"
      @valide="refreshApresModificationMasse"
    />
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';
import moment from 'moment';

export default {
  props: {},
  mounted() {
    this.typeObjet = 'contactExpire';
    this.datasourceContactExpire.refresh();
  },
  data() {
    const datasourceContactExpire = new Datasource('rgpd/contact/expire', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['dateLimiteValidite'],
      descending: [false],
      labelNamespace: 'recherche.rechercheSimple.personnePhysique.list',
      args: {},
      fields: [
        {
          value: 'nom',
          sortable: true,
        },
        {
          value: 'prenoms',
          sortable: true,
        },
        {
          value: 'raisonSociale',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.personneMorale',
          ),
        },
        {
          value: 'cotiseA',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.cotisable',
          ),
        },
        {
          value: 'fonction',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.fonction',
          ),
        },
        {
          value: 'telephone',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.telephone',
          ),
        },
        {
          value: 'mail',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.mail',
          ),
        },
        {
          value: 'dateLimiteValidite',
          sortable: true,
          text: 'Date limite de validité',
        },
      ],
    });

    return {
      datasourceContactExpire,
      typeObjet: 'contactExpire',
      selectedContact: [],
      dialogModifMasse: false,
    };
  },
  /*computed: {
    datasource() {
        return this.datasourceContactExpire;
    },

    nbContacts() {
      return this.datasourceContact.totalRows;
    },
  },*/
  methods: {
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : null;
    },
    demarreModifMasse() {
      var pagination = this.datasourceContactExpire.pagination;
      var selected = this.selectedContact;
      const nb = this.selectedContact.length;
      this.$refs.dialogModifMasse.showModifMasseContactExpire(
        3,
        nb,
        pagination,
        selected,
      );
    },
    refreshApresModificationMasse() {
      this.datasourceContactExpire.refresh();
    },
  },
};
</script>
